import { Component, OnInit } from '@angular/core';
import { MarkdownService } from '@services/markdown/markdown.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-terminos-legales',
  templateUrl: './terminos-legales.component.html',
  styleUrls: ['./terminos-legales.component.scss'],
})
export class TerminosLegalesComponent implements OnInit {


  htmlLegalesGiftCards$: Observable<string>;
  htmlLegalesExperiencias$: Observable<string>;
  htmlLegalesSuperCanjes$: Observable<string>;
  htmlLegalesLatamPass$: Observable<string>;
  constructor(private markdownService: MarkdownService) { }

  ngOnInit() {

    this.htmlLegalesExperiencias$ = this.markdownService.loadMarkdown('assets/legales/canjes_experiencias.md');
    this.htmlLegalesGiftCards$ = this.markdownService.loadMarkdown('assets/legales/canjes_giftcard.md');
    this.htmlLegalesSuperCanjes$ = this.markdownService.loadMarkdown('assets/legales/canjes_supercanjes.md');
    this.htmlLegalesLatamPass$ = this.markdownService.loadMarkdown('assets/legales/canjes_latampass.md');
  }

}
